// src/admin/AdminLiteDashboard.js
import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar
} from 'recharts';
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  CssBaseline,
  IconButton,
  Avatar,
  ListItemIcon,
  Divider,
  Collapse,
  Menu,
  MenuItem,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import ImageIcon from "@mui/icons-material/Image";
import SchoolIcon from "@mui/icons-material/School";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CampaignIcon from "@mui/icons-material/Campaign";
import PersonIcon from "@mui/icons-material/Person";
import { People, AccountBalance } from "@mui/icons-material"; // MUI Icons
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import { Assignment } from "@mui/icons-material";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import avtr from "../assets/avatar.png";
import { GlobalStyles } from "@mui/system";
import SettingsIcon from "@mui/icons-material/Settings";
import EventIcon from "@mui/icons-material/Event";
import { MonetizationOn } from "@mui/icons-material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import RouteIcon from "@mui/icons-material/Route";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import InfoIcon from "@mui/icons-material/Info";
import ListAltIcon     from '@mui/icons-material/ListAlt';
import EditIcon        from '@mui/icons-material/Edit'; 
import BASE_URL from "../config";
import LockResetIcon from '@mui/icons-material/LockReset';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LanguageIcon from '@mui/icons-material/Language';
import BusinessIcon from '@mui/icons-material/Business';
import SmsIcon from '@mui/icons-material/Sms';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ScoreIcon from '@mui/icons-material/Score';
const drawerWidth = 240;
const AdminLiteDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false); // State to manage drawer open/close
  const [imagesOpen, setImagesOpen] = useState(false); // State for "Images" submenu
  const [adminName, setAdminName] = useState("");
  const [isConfigOpen, setIsConfigOpen] = useState(false);
const [isConfigsOpen, setIsConfigsOpen] = useState(false);
const [isConfigssOpen, setIsConfigssOpen] = useState(false);
const [isSmsOpen, setIsSmsOpen] = useState(false);
const [isMarksOpen, setIsMarksOpen] = useState(false);
const [isKSmsOpen, setIsKSmsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Check if screen width is below 'md' (960px)
  // State for mobile menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [feeAnchorEl, setFeeAnchorEl] = useState(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalCash: 0,
    totalTransfer: 0,
    todayCash: 0,
    todayTransfer: 0
  });
  const [feesData, setFeesData] = useState([]);
  const [feesByClass, setFeesByClass] = useState({});

//const [status, setStatus] = useState("");


  // Logout function
  const handleLogout = () => {
    navigate("/admin/login"); // Redirect to admin login page
  };
  // Toggle drawer function
  const toggleDrawer = () => {
    setOpen(!open);
  };
   // open Fee/Payments submenu on hover
  const handleFeeMouseEnter = (event) => {
    setFeeAnchorEl(event.currentTarget);
  };
  const handleFeeMouseLeave = () => {
    setFeeAnchorEl(null);
  };

  // Toggle Images submenu
  const handleImagesClick = () => {
    setImagesOpen(!imagesOpen);
  };
  const handleConfigClick = () => {
    setIsConfigOpen(!isConfigOpen);
  };
  const handleConfigsClick = () => {
    setIsConfigsOpen(!isConfigsOpen);
  };
  const handleConfigssClick = () => {
    setIsConfigssOpen(!isConfigssOpen);
  };
  const handleSmsClick = () => {
    setIsSmsOpen(!isSmsOpen);
  };
  const handleMarksClick = () => {
    setIsMarksOpen(!isMarksOpen);
  };
  const handleKSmsClick = () => {
    setIsKSmsOpen(!isKSmsOpen);
  };
  useEffect(() => {
    if (location.pathname === "/admin/home") {
      // Only fetch when on the dashboard
      fetchDashboardStats();
      fetchFeesByCourse();
       fetchFeesByClass();  // new call
    }
  }, [location.pathname]);

  const fetchDashboardStats = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/dashboard-stats`);
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  };
   const fetchFeesByCourse = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/stats/fees-by-course`);
      setFeesData(res.data);
    } catch (err) {
      console.error("Fees by course error:", err);
    }
  };
  const fetchFeesByClass = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/api/stats/fees-by-course/by-class`);
    setFeesByClass(res.data);
  } catch (err) {
    console.error("Fees by class error:", err);
  }
};
  useEffect(() => {
    const storedName = sessionStorage.getItem("adminName");
    if (!storedName) {
      navigate("/admin/login"); // Redirect if no admin is logged in
    } else {
      setAdminName(storedName); // Set admin name
    }
    const checkInactivity = () => {
      const loginTime = parseInt(sessionStorage.getItem("adminLoginTime"), 10);
      const currentTime = Date.now();
      const timeout = 30 * 60 * 1000; // 15 minutes inactivity timeout
      if (currentTime - loginTime > timeout) {
        alert("You have been logged out due to inactivity.");
        sessionStorage.clear(); // Clear session storage
        navigate("/admin/login"); // Redirect to login
      }
    };
    const interval = setInterval(checkInactivity, 1000); // Check every second
    return () => clearInterval(interval); // Cleanup on component unmount
  }, [navigate]);


/* const handleSend = async () => {
    setStatus("Sending...");
    try {
      const res = await axios.get(`${BASE_URL}/sendDailySummary`);
      setStatus("✅ Test SMS sent successfully!");
    } catch (err) {
      setStatus("❌ Failed to send SMS");
    }
  }; */

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          html: { height: "100%", overflow: "auto" },
          body: { height: "100%", overflow: "auto" },
          "#root": { height: "100%", overflowY: "auto" },
          ".dashboard-container": { height: "100%", overflowY: "auto" },
        }}
      />
      {/* AppBar styled similar to AdminLTE top nav */}
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: "#343a40" }}
      >
        <Toolbar>
          {/* Sidebar Toggle for Mobile */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            edge="start"
            sx={{ display: { xs: "block", md: "none" }, mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          {/* Admin Dashboard Title */}
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            Admin Dashboard
          </Typography>
          {/* Responsive Menu: Show Buttons on Desktop, MenuIcon on Mobile */}
          {isMobile ? (
            <>
              <IconButton color="inherit" onClick={handleMenuOpen}>
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                keepMounted
              >
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate("/students");
                  }}
                >
                  Students
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate("/fee-payments");
                  }}
                >
                  Fee/Payments
                </MenuItem>
                <MenuItem
                onClick={() => {
                  handleMenuClose();
                  navigate("/concessions");
                }}
              >
                Concessions Edit/Delete
              </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMenuClose();
                    navigate("/fee-report");
                  }}
                >
                  Fee Report
                </MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </>
          ) : (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button color="inherit" onClick={() => navigate("/students")}>
                Students
              </Button>
             {/*  <Button color="inherit" onClick={() => navigate("/fee-payments")}>
                Fee/Payments
              </Button> */}
                          <div onMouseLeave={handleFeeMouseLeave}>
              <Button
                color="inherit"
                onMouseEnter={handleFeeMouseEnter}
              >
                Fee/Payments
              </Button>
              <Menu
                anchorEl={feeAnchorEl}
                open={Boolean(feeAnchorEl)}
                onClose={handleFeeMouseLeave}
                MenuListProps={{ onMouseLeave: handleFeeMouseLeave }}
              >
                <MenuItem
                  onClick={() => {
                    setFeeAnchorEl(null);
                    navigate("/fee-payments");
                  }}
                >
                  Fee/Payments
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setFeeAnchorEl(null);
                    navigate("/concessions");
                  }}
                >
                  Concessions Edit/Delete
                </MenuItem>
              </Menu>
            </div>
              <Button color="inherit" onClick={() => navigate("/fee-report")}>
                Fee Report
              </Button>
{/*  <Button color="inherit" onClick={() => navigate("/superadmin-dashboard")}>
                Chairman Dashoard
              </Button> */}

              <Button color="inherit" onClick={handleLogout}>
                Logout
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      {/* Sidebar Drawer */}
      <Drawer
        variant="temporary" // Mobile drawer
        open={open}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }} // Better open performance on mobile
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            bgcolor: "#343a40",
            color: "#ffffff",
          },
        }}
      >
        <SidebarContent
          currentLocation={location}
          toggleDrawer={toggleDrawer}
          handleImagesClick={handleImagesClick}
          imagesOpen={imagesOpen}
          setImagesOpen={setImagesOpen}
          adminName={adminName}
          handleConfigClick={handleConfigClick}
          isConfigOpen={isConfigOpen}
          setIsConfigOpen={setIsConfigOpen}
          handleConfigsClick={handleConfigsClick}
          isConfigsOpen={isConfigsOpen}
          setIsConfigsOpen={setIsConfigsOpen}
          handleConfigssClick={handleConfigssClick}
          isConfigssOpen={isConfigssOpen}
          setIsConfigssOpen={setIsConfigssOpen}
          handleSmsClick={handleSmsClick}
          isSmsOpen={isSmsOpen}
          setIsSmsOpen={setIsSmsOpen}
          handleMarksClick={handleMarksClick}
          isMarksOpen={isMarksOpen}
          setIsMarksOpen={setIsMarksOpen}
          handleKSmsClick={handleKSmsClick}
          isKSmsOpen={isKSmsOpen}
          setIsKSmsOpen={setIsKSmsOpen}
        />
      </Drawer>
      {/* Permanent Sidebar for larger screens */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            bgcolor: "#343a40",
            color: "#ffffff",
          },
        }}
        open
      >
        <SidebarContent
          currentLocation={location}
          toggleDrawer={toggleDrawer}
          handleImagesClick={handleImagesClick}
          imagesOpen={imagesOpen}
          setImagesOpen={setImagesOpen}
          adminName={adminName}
          handleConfigClick={handleConfigClick}
          isConfigOpen={isConfigOpen}
          setIsConfigOpen={setIsConfigOpen} // Add this prop
          handleConfigsClick={handleConfigsClick}
          isConfigsOpen={isConfigsOpen}
          setIsConfigsOpen={setIsConfigsOpen} // Add this prop
          handleConfigssClick={handleConfigssClick}
          isConfigssOpen={isConfigssOpen}
          setIsConfigssOpen={setIsConfigssOpen} // Add this prop
          handleSmsClick={handleSmsClick}
          isSmsOpen={isSmsOpen}
          setIsSmsOpen={setIsSmsOpen} // Add this prop
          handleMarksClick={handleMarksClick}
          isMarksOpen={isMarksOpen}
          setIsMarksOpen={setIsMarksOpen} // Add this prop
          handleKSmsClick={handleKSmsClick}
          isKSmsOpen={isKSmsOpen}
          setIsKSmsOpen={setIsKSmsOpen} // Add this prop
        />
      </Drawer>
      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          bgcolor: "#f4f6f9", // AdminLTE main area background color
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          minHeight: "100vh",
        }}
      >
        {/* Show Stats Only on Dashboard */}
        {location.pathname === "/admin/home" && (
            <>
          <Grid container spacing={3}>
            {/* Total Students */}
            <Grid item xs={12} sm={4}>
              <Card sx={{ boxShadow: 4, borderRadius: 2 }}>
                <CardContent sx={{ textAlign: "center", p: 3 }}>
                  <People sx={{ fontSize: 50, color: "#3f51b5" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color="text.secondary"
                  >
                    Total Students
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" color="primary">
                    {stats.totalStudents !== null
                      ? stats.totalStudents
                      : "Loading..."}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            
            {/* Today's Cash */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  boxShadow: 6,
                  borderRadius: 2,
                  backgroundColor: "#e8f5e9",
                }}
              >
                <CardContent sx={{ textAlign: "center", p: 3 }}>
                  <MonetizationOn sx={{ fontSize: 50, color: "#2e7d32" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color="text.secondary"
                  >
                    Today's Cash
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" color="green">
                    ₹{stats.todayCash ?? "Loading..."}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {/* Today's Transfer */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  boxShadow: 6,
                  borderRadius: 2,
                  backgroundColor: "#fff3e0",
                }}
              >
                <CardContent sx={{ textAlign: "center", p: 3 }}>
                  <AccountBalance sx={{ fontSize: 50, color: "#e65100" }} />
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    color="text.secondary"
                  >
                    Today's Transfer
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" color="orange">
                    ₹{stats.todayTransfer ?? "Loading..."}
                  </Typography>
                  
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {/* Second row: Fees by Course Chart */}
    <Grid container spacing={3} sx={{ mt: 2 }}>
      <Grid item xs={12}>
        <Card sx={{ boxShadow: 4, borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Fees Collected by Course
            </Typography>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={feesData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="course" />
                <YAxis />
                <Tooltip formatter={value => [`₹${value}`, 'Collected']} />
                <Legend verticalAlign="top" />
                <Bar dataKey="totalCollected" name="Collected" fill="#1976d2" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

{/*Fees collected by class for the course */}
{Object.entries(feesByClass).map(([courseName, classData], idx) => (
  <Grid container spacing={3} sx={{ mt: 2 }} key={idx}>
    <Grid item xs={12}>
      <Card sx={{ boxShadow: 4, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Fees Collected Today by Class for <strong>{courseName}</strong>
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={classData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="class" />
              <YAxis />
              <Tooltip formatter={value => [`₹${value}`, 'Collected']} />
              <Legend verticalAlign="top" />
              <Bar dataKey="totalCollected" name="Collected" fill={`hsl(${(idx * 50) % 360}, 70%, 50%)`} />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
))}

  </>
        )}
        <Toolbar />
        <Outlet /> {/* Render the respective component based on the route */}
      </Box>
    </Box>
  );
};
// Sidebar Content component
const SidebarContent = ({
  currentLocation,
  toggleDrawer,
  handleImagesClick,
  imagesOpen,
  setImagesOpen,
  adminName,
  handleConfigClick,
  isConfigOpen,
  setIsConfigOpen,
  handleConfigsClick,
  isConfigsOpen,
  setIsConfigsOpen,
  handleConfigssClick,
  isConfigssOpen,
  setIsConfigssOpen,
  handleSmsClick,
  isSmsOpen,
  setIsSmsOpen,
  handleMarksClick,
  isMarksOpen,
  setIsMarksOpen,
  handleKSmsClick,
  isKSmsOpen,
  setIsKSmsOpen,
}) => (
  <Box>
    <Toolbar />
    <Box sx={{ padding: 2, textAlign: "center" }}>
      <Avatar
        alt="Admin"
        src={avtr}
        sx={{ width: 64, height: 64, marginBottom: 2 }}
      />
      <Typography variant="h6">Welcome, {adminName}</Typography>
      <Typography
        variant="body2"
        style={{ color: "white", fontWeight: "bold" }}
      >
        Administrator
      </Typography>
    </Box>
    <Divider sx={{ bgcolor: "#ffffff" }} />
    <List>
      <SidebarItem
        to="/admin/home"
        label="Dashboard"
        icon={<HomeIcon />}
        active={currentLocation.pathname === "/admin/home"}
        //onClick={toggleDrawer}
        onClick={() => {
          toggleDrawer();
          setImagesOpen(false); // Close the submenu after click
        }}
      />

      <ListItem button onClick={handleConfigClick}>
        <ListItemIcon sx={{ color: "#bdbdbd", minWidth: 40 }}>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="Configuration" />
        {isConfigOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isConfigOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <SidebarItem
            to="/admin/coursespage"
            label="Course"
            icon={<SchoolIcon />}
            active={currentLocation.pathname === "/admin/coursespage"}
            onClick={() => {
              toggleDrawer();
              setIsConfigOpen(false); // Close submenu after click
            }}
          />
          <SidebarItem
            to="/admin/academicyearpage"
            label="Academic Year"
            icon={<EventIcon />}
            active={currentLocation.pathname === "/admin/academicyearpage"}
            onClick={() => {
              toggleDrawer();
              setIsConfigOpen(false); // Close submenu after click
            }}
          />
          <SidebarItem
            to="/admin/feecategory"
            label="Fee Category"
            icon={<MonetizationOn />}
            active={currentLocation.pathname === "/admin/feecategory"}
            onClick={() => {
              toggleDrawer();
              setIsConfigOpen(false); // Close submenu after click
            }}
          />
          <SidebarItem
            to="/admin/class"
            label="Class"
            icon={<MenuBookIcon />}
            active={currentLocation.pathname === "/admin/class"}
            onClick={() => {
              toggleDrawer();
              setIsConfigOpen(false); // Close submenu after click
            }}
          />
           <SidebarItem
            to="/admin/section"
            label="Section"
            icon={<MenuBookIcon />}
            active={currentLocation.pathname === "/admin/section"}
            onClick={() => {
              toggleDrawer();
              setIsConfigOpen(false); // Close submenu after click
            }}
          />
          <SidebarItem
            to="/admin/route"
            label="Route"
            icon={<RouteIcon />}
            active={currentLocation.pathname === "/admin/route"}
            onClick={() => {
              toggleDrawer();
              setIsConfigOpen(false); // Close submenu after click
            }}
          />
          <SidebarItem
  to="/admin/subject"
  label="Subjects"
  icon={<LibraryBooksIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/subjects"}
  onClick={() => {
    toggleDrawer();
    setIsConfigOpen(false);
  }}
/>
<SidebarItem
  to="/admin/ExamPage"
  label="Exams"
  icon={<AssignmentIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/ExamPage"}
  onClick={() => {
    toggleDrawer();
    setIsConfigOpen(false);
  }}
/>
<SidebarItem
  to="/admin/examlist"
  label="ExamLists"
  icon={<ListAltIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/examlist"}
  onClick={() => {
    toggleDrawer();
    setIsConfigOpen(false);
  }}
/>
<SidebarItem
  to="/admin/assignsubject"
  label="Assign Subject"
  icon={<PersonIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/assignsubject"}
  onClick={() => {
    toggleDrawer();
    setIsConfigOpen(false);
  }}
/>
<SidebarItem
        to="/admin/register"
        label="Register Admin"
        icon={<PersonIcon />}
        active={currentLocation.pathname === "/admin/register"}
        //onClick={toggleDrawer}
        onClick={() => {
          toggleDrawer();
          setIsConfigOpen(false); // Close the submenu after click
        }}
      />
<SidebarItem
        to="/admin/change-password"
        label="Change Password"
        icon={<LockResetIcon  />}
        active={currentLocation.pathname === "/admin/change-password"}
        onClick={() => {
          toggleDrawer();
          setIsConfigOpen(false); // Close the submenu after click
        }}
      />
        </List>
      </Collapse>
      <ListItem button onClick={handleConfigsClick}>
        <ListItemIcon
          sx={{
            color: currentLocation.pathname.includes("/admin")
              ? "#ffffff"
              : "#bdbdbd",
            minWidth: 40,
          }}
        >
          <AccountCircleIcon />
        </ListItemIcon>
        <ListItemText primary="Student" />
        {isConfigsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isConfigsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <SidebarItem
            to="/admin/admission"
            label="New Admission"
            icon={<AppRegistrationIcon />}
            active={currentLocation.pathname === "/admin/admission"}
            onClick={() => {
              toggleDrawer();
              setIsConfigsOpen(false); // Close the submenu after click
            }}
          />
          <SidebarItem
            to="/admin/promote"
            label="Promote"
            icon={<UpgradeIcon />}
            active={currentLocation.pathname === "/admin/promote"}
            onClick={() => {
              toggleDrawer();
              setIsConfigsOpen(false); // Close the submenu after click
            }}
          />
        </List>
      </Collapse>
      <ListItem button onClick={handleConfigssClick}>
        <ListItemIcon
          sx={{
            color: currentLocation.pathname.includes("/admin")
              ? "#ffffff"
              : "#bdbdbd",
            minWidth: 40,
          }}
        >
          <LanguageIcon />
        </ListItemIcon>
        <ListItemText primary="Website Configs" />
        {isConfigssOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isConfigssOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <SidebarItem
            to="/admin/carousel"
            label="Carousel Images"
            icon={<ImageIcon />}
            active={currentLocation.pathname === "/admin/carousel"}
            onClick={() => {
              toggleDrawer();
              setIsConfigssOpen(false); // Close the submenu after click
            }}
          />
          <SidebarItem
            to="/admin/album"
            label="Album"
            icon={<ImageIcon />}
            active={currentLocation.pathname === "/admin/album"}
            onClick={() => {
              toggleDrawer();
              setIsConfigssOpen(false); // Close the submenu after click
            }}
          />
          <SidebarItem
            to="/admin/gallery"
            label="Gallery Images"
            icon={<ImageIcon />}
            active={currentLocation.pathname === "/admin/gallery"}
            onClick={() => {
              toggleDrawer();
              setIsConfigssOpen(false); // Close the submenu after click
            }}
          />
          <SidebarItem
            to="/admin/video"
            label="Video"
            icon={<OndemandVideoIcon />}
            active={currentLocation.pathname === "/admin/video"}
            onClick={() => {
              toggleDrawer();
              setIsConfigssOpen(false); // Close the submenu after click
            }}
          />
          <SidebarItem
        to="/admin/contact-detail"
        label="Footer Details"
        icon={<Assignment />}
        active={currentLocation.pathname === "/admin/contact-detail"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
        to="/admin/courses"
        label="Courses"
        icon={<SchoolIcon />}
        active={currentLocation.pathname === "/admin/courses"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
        to="/admin/notifications"
        label="Notification"
        icon={<NotificationsIcon />}
        active={currentLocation.pathname === "/admin/notifications"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
        to="/admin/advirtise"
        label="Advirtise"
        icon={<CampaignIcon />}
        active={currentLocation.pathname === "/admin/advirtise"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
        to="/admin/inquiry"
        label="Inquiries"
        icon={<Assignment />}
        active={currentLocation.pathname === "/admin/inquiry"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
        to="/admin/callback"
        label="Callback Numbers"
        icon={<PhoneCallbackIcon />}
        active={currentLocation.pathname === "/admin/callback"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
        to="/admin/addstaff"
        label="Add Staff"
        icon={<PersonIcon />}
        active={currentLocation.pathname === "/admin/addstaff"}
        onClick={() => {
          toggleDrawer();
          setIsConfigssOpen(false); // Close the submenu after click
        }}
      />
      <SidebarItem
          to="/admin/sections/about-us"
          label="About Us"
          icon={<InfoIcon />}
          active={currentLocation.pathname === "/admin/sections/about-us"}
          onClick={() => toggleDrawer()}
        />
        <SidebarItem
          to="/admin/sections/facilities"
          label="Facilities"
          icon={<BusinessIcon />}
          active={currentLocation.pathname === "/admin/sections/facilities"}
          onClick={() => toggleDrawer()}
        />
        </List>
      </Collapse>
      <ListItem button onClick={handleSmsClick}>
        <ListItemIcon
          sx={{
            color: currentLocation.pathname.includes("/admin")
              ? "#ffffff"
              : "#bdbdbd",
            minWidth: 40,
          }}
        >
          <SmsIcon />
        </ListItemIcon>
        <ListItemText primary="SMS" />
        {isSmsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isSmsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <SidebarItem
            to="/admin/sendmessage"
            label="Send Notification"
            icon={<SmsIcon />}
            active={currentLocation.pathname === "/admin/sendmessage"}
            onClick={() => {
              toggleDrawer();
              setIsSmsOpen(false); // Close the submenu after click
            }}
          />
          <SidebarItem
  to="/admin/send-absent"
  label="Send Absent SMS"
  icon={<NotificationImportantIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/send-absent"}
  onClick={() => {
    toggleDrawer();
    setIsSmsOpen(false);
  }}
/>

<SidebarItem
  to="/admin/send-balance"
  label="Fee Balance SMS"
  icon={<NotificationImportantIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/send-balance"}
  onClick={() => {
    toggleDrawer();
    setIsSmsOpen(false);
  }}
/>
        </List>
      </Collapse>

<ListItem button onClick={handleKSmsClick}>
        <ListItemIcon
          sx={{
            color: currentLocation.pathname.includes("/admin")
              ? "#ffffff"
              : "#bdbdbd",
            minWidth: 40,
          }}
        >
          <SmsIcon />
        </ListItemIcon>
        <ListItemText primary="KANNADA SMS" />
        {isKSmsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isKSmsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <SidebarItem
            to="/admin/sendkmessage"
            label="Send Kannada Notification"
            icon={<SmsIcon />}
            active={currentLocation.pathname === "/admin/sendkmessage"}
            onClick={() => {
              toggleDrawer();
              setIsKSmsOpen(false); // Close the submenu after click
            }}
          />
        </List>
      </Collapse>

    <ListItem button onClick={handleMarksClick}>
        <ListItemIcon
          sx={{
            color: currentLocation.pathname.includes("/admin")
              ? "#ffffff"
              : "#bdbdbd",
            minWidth: 40,
          }}
        >
          <ScoreIcon />
        </ListItemIcon>
        <ListItemText primary="Marks" />
        {isMarksOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isMarksOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
   <SidebarItem
  to="/admin/markspagelist"
  label="MarksPageList"
  icon={<ListAltIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/markspagelist"}
  onClick={() => {
    toggleDrawer();
    setIsMarksOpen(false);
  }}
/>
<SidebarItem
  to="/admin/markseditpage"
  label="MarksEditPage"
  icon={<EditIcon />} // Optional: You can change the icon to something like <AssessmentIcon />
  active={currentLocation.pathname === "/admin/markseditpage"}
  onClick={() => {
    toggleDrawer();
    setIsMarksOpen(false);
  }}
/>
        </List>
      </Collapse>   
    </List>
  </Box>
);
// Sidebar Item Component for each menu item with active state styling
const SidebarItem = ({ to, label, icon, active, onClick }) => (
  <ListItem
    button
    component={Link}
    to={to}
    onClick={onClick}
    sx={{
      color: active ? "#ffffff" : "#bdbdbd",
      fontWeight: active ? "bold" : "normal",
      backgroundColor: active ? "#495057" : "transparent",
      pl: active ? 3 : 2, // Adds left padding for active items
      borderLeft: active ? "4px solid #ffffff" : "none", // Left border for active items
      "&:hover": {
        backgroundColor: "#495057",
        color: "#ffffff",
        borderLeft: "4px solid #ffffff",
      },
    }}
  >
    <ListItemIcon sx={{ color: active ? "#ffffff" : "#bdbdbd", minWidth: 40 }}>
      {icon}
    </ListItemIcon>
    <ListItemText primary={label} />
  </ListItem>
);
export default AdminLiteDashboard;
